// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"5":"c6593298","211":"8d74ff9c","260":"9ed1cbb7"}[chunkId] + ".js";
};